module.exports = __webpack_public_path__ + "img/icon-christmas-3.71e66066.svg";